import type { ContactUsConfig } from './types'
import { commonTexts } from './common'

/**
 * Vowpath 品牌 Contact Us 页面配置（深色主题）
 */
export const contactUsConfig: ContactUsConfig = {
  texts: commonTexts,
  colors: {
    bgPrimary: '#20214A', // 主背景（深蓝紫）
    bgTertiary: 'rgba(255, 255, 255, 0.06)', // 输入区背景
    textPrimary: '#FFFFFF', // 主要文本
    textTertiary: 'rgba(255, 255, 255, 0.4)', // 三级文本（字数统计）
    textPlaceholder: 'rgba(255, 255, 255, 0.35)', // 占位符文本
    accentRed: '#FF5C7A', // 红色强调（必填星号）
    primaryColor: '#BB7AFB', // 品牌主色
    whiteColor: '#FFFFFF', // 白色
    inputBorder: 'rgba(255, 255, 255, 0.1)', // 输入区边框
    submitGradient: 'linear-gradient(90deg, #A162FF 0%, #FF6BD2 100%)', // 提交按钮渐变
    submitShadow: '0 8px 24px rgba(255, 107, 210, 0.35)', // 提交按钮光晕
  },
}
